module.exports = __webpack_public_path__ + "static/media/ill1-academia.3dcb429c.svg";